import { Builder } from "@builder.io/react";

import OldPressComponent from "./OldPressComponent.jsx";

Builder.registerComponent(OldPressComponent, {
  name: "Old Press Page Content",
  inputs: []
})